import React, { useEffect, useState } from "react";
import {
  Box, VStack, Text, Spinner, Alert, AlertIcon,
  Button, Icon, Heading,
} from "@chakra-ui/react";
import { FaCheckCircle } from "react-icons/fa";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

const B2CPaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("b2c_token");

  const [status, setStatus] = useState<"polling" | "success" | "failed">("polling");
  const [practiceSetId, setPracticeSetId] = useState<number | null>(null);

  useEffect(() => {
    if (!sessionId) { setStatus("failed"); return; }

    let attempts = 0;
    const maxAttempts = 20; // poll for up to 20 seconds

    const poll = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/b2c/purchase/status?session_id=${sessionId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const { status: purchaseStatus, practice_set_id } = response.data;

        if (purchaseStatus === "COMPLETED") {
          setPracticeSetId(practice_set_id);
          setStatus("success");
          return;
        }
        if (purchaseStatus === "FAILED") {
          setStatus("failed");
          return;
        }
      } catch { /* keep polling */ }

      attempts++;
      if (attempts >= maxAttempts) {
        // Webhook may still be in flight -- show success anyway
        // and let them navigate to dashboard
        setStatus("success");
        return;
      }
      setTimeout(poll, 1000);
    };

    poll();
  }, [sessionId]);

  if (status === "polling") {
    return (
      <Box maxW="500px" mx="auto" mt={20} textAlign="center">
        <VStack spacing={4}>
          <Spinner size="xl" color="purple.500" />
          <Text fontSize="lg" fontWeight="semibold">
            Confirming your payment...
          </Text>
          <Text color="gray.500" fontSize="sm">
            Please wait, this usually takes a few seconds.
          </Text>
        </VStack>
      </Box>
    );
  }

  if (status === "failed") {
    return (
      <Box maxW="500px" mx="auto" mt={20} textAlign="center" p={8}>
        <Alert status="error" borderRadius="xl" mb={6}>
          <AlertIcon />
          Payment could not be confirmed. Please contact support@eduvic.com.au
          with your order reference.
        </Alert>
        <Button colorScheme="purple" onClick={() => navigate("/practice")}>
          Return to Home
        </Button>
      </Box>
    );
  }

  return (
    <Box maxW="500px" mx="auto" mt={20} textAlign="center" p={8}>
      <VStack spacing={5}>
        <Icon as={FaCheckCircle} boxSize={16} color="green.400" />
        <Heading size="lg">Payment Successful!</Heading>
        <Text color="gray.500">
          Your access has been activated. You can start practising immediately.
        </Text>
        <Button
          colorScheme="purple"
          size="lg"
          width="100%"
          onClick={() =>
            navigate("/practice/app/")
          }
        >
          Start Practising
        </Button>
      </VStack>
    </Box>
  );
};

export default B2CPaymentSuccess;